export enum TOAST_TYPES {
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  INFO = 'INFO'
}